<!-- Redefine Header -->
<app-redefine-header></app-redefine-header>

<!-- Contact Hero -->
<section class="contact-hero">
    <div class="container">
        <span class="section-accent"></span>
        <h1>Get in touch</h1>
        <p>Our team is here to help you find the perfect parking solution.</p>
    </div>
</section>

<!-- Contact Content -->
<section class="contact-section">
    <div class="container">
        <div class="contact-grid">
            <!-- Contact Form -->
            <div class="contact-form-wrapper">
                <div class="form-card" *ngIf="!submitted">
                    <h2>Send us a message</h2>
                    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                        <div class="form-row">
                            <div class="form-group">
                                <label for="name">Full name *</label>
                                <input type="text" id="name" formControlName="name" placeholder="Your full name" />
                            </div>
                            <div class="form-group">
                                <label for="email">Email address *</label>
                                <input type="email" id="email" formControlName="email" placeholder="you@company.com" />
                            </div>
                        </div>
                        
                        <div class="form-row">
                            <div class="form-group">
                                <label for="phone">Phone number</label>
                                <input type="tel" id="phone" formControlName="phone" placeholder="+27 XX XXX XXXX" />
                            </div>
                            <div class="form-group">
                                <label for="company">Company</label>
                                <input type="text" id="company" formControlName="company" placeholder="Your company name" />
                            </div>
                        </div>
                        
                        <div class="form-group full-width">
                            <label for="message">Message *</label>
                            <textarea id="message" formControlName="message" rows="5" placeholder="Tell us about your parking needs..."></textarea>
                        </div>
                        
                        <div class="form-error" *ngIf="error">
                            <i class="fa-solid fa-exclamation-circle"></i>
                            {{ error }}
                        </div>
                        
                        <button type="submit" class="btn-submit" [disabled]="contactForm.invalid || submitting">
                            <span *ngIf="!submitting">Send message</span>
                            <span *ngIf="submitting"><i class="fa-solid fa-spinner fa-spin"></i> Sending...</span>
                        </button>
                    </form>
                </div>
                
                <!-- Success Message -->
                <div class="form-card success-card" *ngIf="submitted">
                    <div class="success-content">
                        <i class="fa-solid fa-check-circle"></i>
                        <h2>Message sent</h2>
                        <p>Thank you for reaching out. Our team will get back to you within 24 hours.</p>
                        <a routerLink="/" class="btn-secondary">Return to home</a>
                    </div>
                </div>
            </div>
            
            <!-- Contact Info -->
            <div class="contact-info">
                <div class="info-card">
                    <h3>Contact details</h3>
                    <ul class="info-list">
                        <li>
                            <i class="fa-solid fa-envelope"></i>
                            <div>
                                <span class="label">Email</span>
                                <a href="mailto:{{ globalService.contactEmail }}">{{ globalService.contactEmail }}</a>
                            </div>
                        </li>
                        <li *ngIf="globalService.contactPhone">
                            <i class="fa-solid fa-phone"></i>
                            <div>
                                <span class="label">Phone</span>
                                <a href="tel:{{ globalService.contactPhone }}">{{ globalService.contactPhone }}</a>
                            </div>
                        </li>
                        <li>
                            <i class="fa-solid fa-location-dot"></i>
                            <div>
                                <span class="label">Office</span>
                                <span>Rosebank, Johannesburg<br />South Africa</span>
                            </div>
                        </li>
                        <li>
                            <i class="fa-solid fa-clock"></i>
                            <div>
                                <span class="label">Hours</span>
                                <span>Monday - Friday<br />08:00 - 17:00</span>
                            </div>
                        </li>
                    </ul>
                </div>
                
                <div class="info-card">
                    <h3>Looking for parking?</h3>
                    <p>Browse our portfolio of premium parking locations across South Africa.</p>
                    <a (click)="viewAllProperties()" class="btn-outline">View properties</a>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Redefine Footer -->
<app-redefine-footer></app-redefine-footer>

